import React from "react";
import classNames from "classnames";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { FlexComponent } from "components/templates";
import { Title, Logo, Button } from "components/atoms";
import { NotificationButton, UserButton } from "components/molecules";
import { useAppSettings } from "_hooks";
import { selectUser } from "_redux/user/user.selectors";

const Header = () => {
  const classForComponent = classNames("o-header", {});
  const { appLookAndFeel } = useAppSettings();
  const { t } = useTranslation();
  const user = useSelector(selectUser);

  const canSwitchWorkspace = user?.workspacesId?.length > 1;

  return (
    <header className={classForComponent}>
      <FlexComponent>
        {appLookAndFeel?.customerLogo ?
          <img alt="logo" src={appLookAndFeel.customerLogo}/>
          :
          <Logo color="var(--color-white)" />
        }

        <Title content={appLookAndFeel?.account?.name ?? ""} />

        {canSwitchWorkspace &&
          <Button
            className="o-header__switch"
            content={t("common:tabSync.switchWorkspace")}
            onClick={() => window.location.assign(`${process.env.REACT_APP_CORE_WEB}/account/select`)}
            xs
            type="underline"
          />
        }
      </FlexComponent>
      <FlexComponent>
        <NotificationButton />
        <UserButton />
      </FlexComponent>
    </header>
  );
};

export default Header;
